<div
  class="flex max-h-80 flex-col gap-6x overflow-auto"
  style="width: 20rem"
  stop-propagation
>
  <div
    class="flex items-center gap-1 font-text font-normal text-grey-100"
    *ngIf="showSummaryText && locationCount > 0"
  >
    <span
      [innerHTML]="
        'components.product_locations_info.in_x_stores_prefix'
          | translate: { count: locationCount }
      "
    >
    </span>
    <ng-container
      *ngIf="getFormattedDiffSummaryPart(locationDiff) as diffSummary"
    >
      <span
        class="product-location-diff"
        [ngClass]="'product-location-diff--' + diffSummary.diffClass"
        ngxTippy
        tippyClassName="tippy-white"
        [tippyProps]="{ content: diffSummary.tooltip }"
      >
        {{ diffSummary.formattedDiff }}
      </span>
    </ng-container>
    <span
      [innerHTML]="
        'components.product_locations_info.in_x_stores_suffix' | translate
      "
    >
    </span>
  </div>

  <div class="flex flex-col">
    <div *ngFor="let owner of locations" class="flex flex-col">
      <div
        class="product-location-item"
        id="product-location-item-{{ i }}"
        [class.toggled]="tooltipAccordionOpenOwnerIds?.includes(owner.ownerId)"
        (click)="toggleOwnerExpand(owner)"
      >
        <div class="flex items-center gap-1">
          <toggle-arrow
            [toggled]="tooltipAccordionOpenOwnerIds?.includes(owner.ownerId)"
            class="size--sm"
          ></toggle-arrow>
          <span>
            {{ owner.ownerName }}
          </span>
        </div>

        <div class="flex items-center gap-2">
          <span class="font-text text-sm font-medium text-grey-100">{{
            getActiveLocationCount(owner.locations)
          }}</span>
          <ng-container
            *ngIf="
              showSummaryText &&
              getFormattedDiffSummaryPart(
                getOwnerLocationDiff(owner)
              ) as diffSummary
            "
          >
            <div class="flex min-w-[36px] justify-start">
              <span
                class="product-location-diff"
                [ngClass]="'product-location-diff--' + diffSummary.diffClass"
                ngxTippy
                tippyClassName="tippy-white"
                [tippyProps]="{
                  content: diffSummary.tooltip
                }"
              >
                {{ diffSummary.formattedDiff }}
              </span>
            </div>
          </ng-container>
        </div>
      </div>
      <ng-container
        *ngIf="tooltipAccordionOpenOwnerIds?.includes(owner.ownerId)"
      >
        <div class="product-location-item--dropdown">
          <div
            *ngFor="let location of owner.locations"
            class="font-text text-sm text-dirtyPurple {{
              getStatusClass(location.status)
            }}"
          >
            {{ location.name }}
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
